// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.formItemInput[data-v-7d7094a4]{\n  width: 200px;\n}\n", ""]);
